<template>
  <el-card class="card">
    <img :src="photo" class="photo">
    <div class="info">
      <span class="name-en">{{ name_en }}</span>
      <span v-if="name!==''" class="name">{{ name }}</span>
      <span v-if="year!==null" class="year">{{ year }}</span>
      <span class="email">{{ email }}</span>
      <span v-if="duration!==''" class="duration">{{duration}}</span>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "MemberInfo",
  props: {
    name: {
      type: String,
      default: ''
    },
    name_en: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    },
    year: {
      type: Number
    },
    duration: {
      type: String,
      default: ''
    },
  }
}
</script>

<style scoped>

.card {
  margin: 16px;
  display: inline-block;
}

.info {

}

.photo {
  width: 300px;
  height: 375px;
  margin: auto;
}

.name-en {
  font-weight: bold;
  font-size: 18px;
}

.name {
  color: silver;
  margin-left: 16px;
}

.year {
  float: right;
  right: 0;
}

.email,.duration{
  display: block;
}
</style>